import { AddressSearchAction } from './actions';

import {
  ADDRESS_SEARCH_REQUEST_START,
  ADDRESS_SEARCH_REQUEST_FAIL,
  ADDRESS_SEARCH_REQUEST_SUCCESS,
  ADDRESS_RETRIEVE_REQUEST_START,
  ADDRESS_RETRIEVE_REQUEST_FAIL,
  ADDRESS_RETRIEVE_REQUEST_SUCCESS,
  ADDRESS_SEARCH_CLEAR_ALL
} from './types';

type AddressSearchState = {
  retrieve: {
    loadingState: string,
    results: any
  },
  search: {
    loadingState: string,
    results: any
  },
  jointRetrieve: {
    loadingState: string,
    results: any
  },
  jointSearch: {
    loadingState: string,
    results: any
  }
};

export const INITIAL_STATE: AddressSearchState = {
  retrieve: {
    loadingState: 'UNINITIALISED',
    results: null
  },
  search: {
    loadingState: 'UNINITIALISED',
    results: null
  },
  jointRetrieve: {
    loadingState: 'UNINITIALISED',
    results: null
  },
  jointSearch: {
    loadingState: 'UNINITIALISED',
    results: null
  }
};

export const reducer = (
  state = INITIAL_STATE,
  action: AddressSearchAction
): AddressSearchState => {
  switch (action.type) {
    case ADDRESS_SEARCH_REQUEST_START:
      return {
        ...state,
        jointSearch: (action.payload.isJoint) ? {
          ...state.jointSearch,
          loadingState: 'LOADING',
          results: null
        } : {
          ...state.jointSearch
        },
        search: (!action.payload.isJoint) ? {
          ...state.search,
          loadingState: 'LOADING',
          results: null
        } : {
          ...state.search
        }
      };

    case ADDRESS_SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        jointSearch: (action.payload.isJoint) ? {
          ...state.jointSearch,
          loadingState: 'LOADED',
          results: action.payload.data.Items
        } : {
          ...state.jointSearch
        },
        search: (!action.payload.isJoint) ? {
          ...state.search,
          loadingState: 'LOADED',
          results: action.payload.data.Items
        } : {
          ...state.search
        }
      };

    case ADDRESS_SEARCH_REQUEST_FAIL:
      return {
        ...state,
        jointSearch: (action.payload.isJoint) ? {
          ...state.jointSearch,
          loadingState: 'ERROR',
          results: null
        } : {
          ...state.jointSearch
        },
        search: (!action.payload.isJoint) ? {
          ...state.search,
          loadingState: 'ERROR',
          results: null
        } : {
          ...state.search
        }
      };

    case ADDRESS_RETRIEVE_REQUEST_START:
      return {
        ...state,
        jointRetrieve: (action.payload.isJoint) ? {
          ...state.jointRetrieve,
          loadingState: 'LOADING',
          results: null
        } : {
          ...state.jointRetrieve
        },
        retrieve: (!action.payload.isJoint) ? {
          ...state.retrieve,
          loadingState: 'LOADING',
          results: null
        } : {
          ...state.retrieve
        }
      };

    case ADDRESS_RETRIEVE_REQUEST_SUCCESS:
      return {
        ...state,
        jointRetrieve: (action.payload.isJoint) ? {
          ...state.jointRetrieve,
          loadingState: 'LOADED',
          results: action.payload.data.Items
        } : {
          ...state.jointRetrieve
        },
        retrieve: (!action.payload.isJoint) ? {
          ...state.retrieve,
          loadingState: 'LOADED',
          results: action.payload.data.Items
        } : {
          ...state.retrieve
        }
      };

    case ADDRESS_RETRIEVE_REQUEST_FAIL:
      return {
        ...state,
        jointRetrieve: (action.payload.isJoint) ? {
          ...state.jointRetrieve,
          loadingState: 'ERROR',
          results: null
        } : {
          ...state.jointRetrieve
        },
        retrieve: (!action.payload.isJoint) ? {
          ...state.retrieve,
          loadingState: 'ERROR',
          results: null
        } : {
          ...state.retrieve
        }
      };

    case ADDRESS_SEARCH_CLEAR_ALL:
      return {
        retrieve: (action.payload.isJoint) ? {
          ...state.retrieve
        } : {
          loadingState: 'UNINITIALISED',
          results: null
        },
        search: (action.payload.isJoint) ? {
          ...state.search
        } : {
          loadingState: 'UNINITIALISED',
          results: null
        },
        jointRetrieve: (action.payload.isJoint) ? {
          loadingState: 'UNINITIALISED',
          results: null
        } : {
          ...state.jointRetrieve
        },
        jointSearch: (action.payload.isJoint) ? {
          loadingState: 'UNINITIALISED',
          results: null
        } : {
          ...state.jointSearch
        }
      };

    default:
      return state;
  }
};